import { checkColor, rad, withColor, type PieceKind, type Placed, type PrimKind } from "./types";

/** A straight ramp rising from 0 to `h` over `len`, ±hw across. */
export interface KickerPrim extends Placed {
  kind: "kicker";
  len: number;
  h: number;
  /** Render only (#115): its own color. */
  color?: string;
}

export interface KickerPiece {
  kind: "kicker";
  x: number;
  z: number;
  rot?: number;
  len: number;
  hw: number;
  h: number;
  /** Its own color (#115), over the map's `look.pieces`. */
  color?: string;
}

export const KICKER: PrimKind<KickerPrim> = {
  eval: (p, u, w) =>
    u >= 0 && u <= p.len && Math.abs(w) <= p.hw ? { h: (p.h * u) / p.len, du: p.h / p.len, dw: 0 } : null,
  extent: (p) => [0, p.len],
  shadow: 0.35,
  top: (p) => p.h,
  plan: (p) => [{ u0: 0, u1: p.len, fill: "kicker" }],
};

export const KICKER_PIECE: PieceKind<KickerPiece> = {
  fields: ["x", "z", "rot", "len", "hw", "h", "color"],
  placed: true,
  check(c, o, path, bounds) {
    c.num(o, "len", path, { min: 0.05, max: 2 * bounds });
    c.num(o, "h", path, { min: 0.05, max: 20 });
    checkColor(c, o, path);
  },
  compile(p, out) {
    out.prims.push(withColor<KickerPrim>({ kind: "kicker", x: p.x, z: p.z, rot: rad(p.rot), len: p.len, hw: p.hw, h: p.h }, p.color));
  },
};
